/* Product cards (home, collections, search): when a product's 2nd media is a video, it plays on mouse-over, muted and
   looping, and stops when the mouse leaves. Desktop only. Needs the card to show its secondary image on hover
   (the snippet only outputs the <video> then). 4 Oct 2026. */
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var st = document.createElement('style');
  st.textContent = '.card__hover-video{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;opacity:0;' +
    'transition:opacity .25s ease;pointer-events:none;z-index:2}.card__hover-video.is-playing{opacity:1}' +
    '.card__media:has(.card__hover-video){-webkit-mask-image:-webkit-radial-gradient(white,black);mask-image:radial-gradient(white,black)}';
  document.head.appendChild(st);

  function start(v) {
    if (!v.getAttribute('src') && v.dataset.hoverSrc) v.src = v.dataset.hoverSrc;
    // a playing video is its own layer and ignores the card's rounded clip: give it the same corners
    var m = v.closest('.card__media');
    if (m) {
      var r = getComputedStyle(m).borderRadius;
      v.style.borderRadius = r;
      v.style.clipPath = 'inset(0 round ' + r + ')';
    }
    v.muted = true;
    v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    if (!v.paused && v.readyState > 2) v.classList.add('is-playing');
  }
  function stop(v) {
    v.pause();
    v.classList.remove('is-playing');
    try { v.currentTime = 0; } catch (e) {}
  }
  if (!canHover) {
    // Touch screens (phones, tablets): no hover, so the video plays by itself while its card is on screen (muted, looping).
    // Skipped for Data Saver and reduced-motion settings.
    var saver = navigator.connection && navigator.connection.saveData;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (saver || calm || !('IntersectionObserver' in window)) return;
    var seen = new WeakSet();
    // the video starts hidden (opacity 0, no size on first paint), so watch its card picture instead
    var scan2 = function () {
      document.querySelectorAll('.card__hover-video').forEach(function (v) {
        if (seen.has(v)) return; seen.add(v);
        var box = v.closest('.card__media') || v;
        var io2 = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { v.setAttribute('playsinline', ''); start(v); } else stop(v); });
        }, { threshold: 0.6 });
        io2.observe(box);
      });
    };
    scan2();
    new MutationObserver(function () { scan2(); }).observe(document.body, { childList: true, subtree: true });
    return;
  }
  document.addEventListener('mouseover', function (e) {
    var w = e.target.closest && e.target.closest('.card-wrapper');
    var v = w && w.querySelector('.card__hover-video');
    if (v) start(v);
  });
  document.addEventListener('mouseout', function (e) {
    var w = e.target.closest && e.target.closest('.card-wrapper');
    if (!w || (e.relatedTarget && w.contains(e.relatedTarget))) return;
    var v = w.querySelector('.card__hover-video');
    if (v) stop(v);
  });
})();
